import { render, staticRenderFns } from "./contactCen.vue?vue&type=template&id=1cfe69cd&scoped=true"
import script from "./contactCen.vue?vue&type=script&lang=js"
export * from "./contactCen.vue?vue&type=script&lang=js"
import style1 from "./contactCen.vue?vue&type=style&index=1&id=1cfe69cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe69cd",
  null
  
)

export default component.exports